<div class="hero-banner" aria-roledescription="carousel">
  <!-- Slides -->
  @for (img of bannerImages(); track img; let i = $index) {
    <div
      class="banner-slide"
      [class.active]="i === currentIndex()"
      [attr.aria-hidden]="i !== currentIndex()"
    >
      <img [src]="img" [alt]="'Banner ' + (i + 1)" />
    </div>
  }

  <!-- Navegación -->
  <button
    type="button"
    class="banner-nav prev"
    (click)="prev()"
    aria-label="Anterior"
  >
    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 text-[#231f20]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M15 19l-7-7 7-7" />
    </svg>
  </button>

  <button
    type="button"
    class="banner-nav next"
    (click)="next()"
    aria-label="Siguiente"
  >
    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 text-[#231f20]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7" />
    </svg>
  </button>

  <!-- Indicador inferior: actual + siguiente -->
  <div class="banner-indicator" aria-label="Indicador de banners">
    @for (img of bannerImages(); track img; let i = $index) {
      <button
        type="button"
        class="thumb"
        [class.active]="i === currentIndex()"
        [class.up-next]="i === nextIndex()"
        (click)="goToSlide(i)"
        [attr.aria-label]="'Ir al banner ' + (i + 1)"
      >
        <img [src]="img" [alt]="'Miniatura ' + (i + 1)" />
      </button>
    }

    <div class="banner-counter">
      <span class="current">{{ currentIndex() + 1 }}</span>
      <span class="sep">/</span>
      <span class="total">{{ bannerImages().length }}</span>
      <span class="upnext-text">
        · Siguiente: {{ nextIndex() + 1 }}
      </span>
    </div>
  </div>
</div>
